import {getAuth} from "../helper/utils/getAuth";

export function checkIntegrationFn(key) {
    if (key.length === 0)
        return true;

    const { company } = getAuth();
    const { extension_slugs: extensionSlugs = [] } = company || {};
    return !(extensionSlugs || []).includes(key);
}
